<template>
  <div v-if="!model.$disabled" :class="{ 'inline-block': inline }">
    <div class="custom-control custom-radio" :class="{ 'inline-block': inline }">
      <input
        :id="sid"
        ref="input"
        type="radio"
        class="custom-control-input"
        tabindex="0"
        :aria-invalid="errorVisible"
        :aria-describedby="showError && errorVisible ? errId : undefined"
        :class="borderValidationClass"
        :checked="checked"
        :disabled="disabled"
        :value="value"
        :name="model.$form.testPath ? model.$path : sid"
        @click="onClick($event)"
        @change="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
      />
      <label class="custom-control-label" :for="sid">
        <slot>{{ getTitle }}</slot>
      </label>

      <w-error v-if="showError" :err-id="errId" :model="model" />
    </div>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import { errorMixin } from '../mixins/errorMixin';
import WError from './error.vue';

export default {
  // props: ['model', 'value'],
  name: 'WRadio',
  components: {
    WError
  },
  mixins: [modelMixin, errorMixin('rad')],
  props: {
    inline: Boolean,
    showError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    checked() {
      // if (this.$options.hasFocus) {
      //   return this.model.$model === this.value;
      // }
      if (this.model.$model instanceof Array) {
        return this.model.$model.includes(this.value);
      } else {
        return this.model.$model === this.value;
      }
    }
  },
  // mounted() {},
  methods: {
    onClick(evt) {
      this.$options.hasFocus = true;
      this.$emit('click');
      this.model.$hasFocus = true;
    },
    onFocus(evt) {
      this.$options.hasFocus = true;
      this.$emit('focus');
      this.model.$hasFocus = true;
    },
    onBlur(evt) {
      this.$options.hasFocus = false;
      this.$emit('blur');
      this.model.$hasFocus = false;
    },
    onInput(evt) {
      this.$options.localValue = evt.target.checked;
      if (evt.target.checked) {
        if (this.model.$model instanceof Array) {
          const ii = this.model.$model.indexOf(this.value);
          if (ii > -1) {
            this.model.$model.splice(0);
          }

          this.model.$model.push(this.value);
        } else {
          this.model.$model = this.value;
        }
      }
      this.$emit('input');
      this.fieldChanged();
    }
  }
};
</script>

<style>
.radio-inline,
.inline-block {
  display: inline-block !important;
}
</style>
